import _ol_style_IconImageCache_ from './style/iconimagecache.js';
var _ol_style_ = {};

/**
 * The {@link ol.style.IconImageCache} for {@link ol.style.Icon} images.
 * @api
 */
_ol_style_.iconImageCache = new _ol_style_IconImageCache_();
export default _ol_style_;
